import { create } from 'zustand';

import type { AuthSession } from '@logistech/ui-shared';
import { clearBrowserStorage } from '@logistech/ui';

import { sessionStorage } from '@/lib/storage';

interface AuthState {
  session: AuthSession | null;
  hydrate(): void;
  setSession(s: AuthSession): void;
  logout(): Promise<void>;
}

export const useAuth = create<AuthState>((set) => ({
  session: sessionStorage.get(),
  hydrate() {
    set({ session: sessionStorage.get() });
  },
  setSession(s) {
    sessionStorage.set(s);
    set({ session: s });
  },
  // Le cache React Query est persisté dans localStorage (main.tsx) : il part avec le reste
  async logout() {
    sessionStorage.clear();
    set({ session: null });
    await clearBrowserStorage();
  },
}));
